import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/linked-to/fleets")({
  staticData: {
    title: "linkedTo.fleet.title",
  },
});
